import Text from 'components/Text/Text';
import React, { useContext, useRef } from 'react';
import { IDishesContext, DishesContext } from '../../../dishesState/dishesContext';
import { Select } from 'antd';
import style from './CountOfItem.module.scss';

const { Option } = Select;

export const CountOfItem: React.FC = () => {
	const { setCountOfItems, countOfItems } = useContext<IDishesContext>(DishesContext);
	const parentNodeRef = useRef<null | HTMLSpanElement>(null);

	return (
		<div className={style.container} data-test="CountOfItem">
			<Text translationNameSpace="listing" translationKey="showLabel" />
			<span ref={parentNodeRef} style={{ position: 'relative' }} />
			<Select
				className={style.select}
				onChange={setCountOfItems}
				value={countOfItems}
				getPopupContainer={() => parentNodeRef.current as HTMLSpanElement}
				placeholder="Select">
				<Option className={style.listItem} value="12">
					12
				</Option>
				<Option className={style.listItem} value="24">
					24
				</Option>
				<Option className={style.listItem} value="48">
					48
				</Option>
			</Select>
			<Text translationNameSpace="listing" translationKey="entriesLabel" />
		</div>
	);
};
